import { useSelector } from 'react-redux';
import { IStore } from '../store/types';
import { can, Permissions, Requirement } from './permissions';

export const usePermissions = (): Permissions | undefined =>
    useSelector<IStore, Permissions | undefined>((state) => state.auth.data?.permissions);

/** `true` when the signed-in user satisfies the requirement (moderators always do). */
export const useCan = (requirement: Requirement): boolean => can(usePermissions(), requirement);
